import { render, staticRenderFns } from "./PointSignin.vue?vue&type=template&id=dbf91d36&scoped=true"
import script from "./PointSignin.vue?vue&type=script&lang=js"
export * from "./PointSignin.vue?vue&type=script&lang=js"
import style0 from "./PointSignin.vue?vue&type=style&index=0&id=dbf91d36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf91d36",
  null
  
)

export default component.exports